import { useSyncExternalStore } from 'react';

export interface MockSyncStatus {
  /** True once synchronization runs in this portal. */
  enabled: boolean;
  peerPortal?: 'internal' | 'vendor';
  peerUrl?: string;
  /** True while at least one window of the other portal is reachable. */
  connected: boolean;
  /** Local changes the other portal has not acknowledged yet. */
  pending: number;
  /** Increments whenever data changed underneath the visible page. */
  revision: number;
}

let status: MockSyncStatus = { enabled: false, connected: false, pending: 0, revision: 0 };
const listeners = new Set<() => void>();

export const getMockSyncStatus = (): MockSyncStatus => status;

export function subscribeMockSyncStatus(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function updateMockSyncStatus(patch: Partial<MockSyncStatus>): void {
  const next = { ...status, ...patch };
  if ((Object.keys(next) as (keyof MockSyncStatus)[]).every((key) => next[key] === status[key])) return;
  status = next;
  for (const listener of [...listeners]) listener();
}

export function bumpMockDataRevision(): void {
  updateMockSyncStatus({ revision: status.revision + 1 });
}

export function useMockSyncStatus(): MockSyncStatus {
  return useSyncExternalStore(subscribeMockSyncStatus, getMockSyncStatus, getMockSyncStatus);
}
